<template>
  <div class="order-wrap">
    <div class="tips" v-show="wrong_count > 0" @click="unusual = 'unusual'">
      你有{{ wrong_count }}个异常订单，请及时处理
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getOrderData"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        class="order-list"
        @click="goToOrderDetail(item.order_sn)"
      >
        <div class="time">预定时间: {{ item.start_date }}</div>
        <van-panel>
          <div slot="header" class="head-bar van-hairline--bottom">
            <div class="left">{{ item.region }}</div>
            <!-- , {{ item.refund_status }} -->
            <div class="right" :class="{ sucess: item.status == 10 }">
              {{ orderStatus(item.status, item.refund_status) }}
              <span class="right-text" v-if="item.refund_status == 1">部分退款中</span>
            </div>
          </div>
          <div class="order-info">
            <div class="imgs">
              <img :src="item.crop_image" alt />
            </div>
            <div class="name van-multi-ellipsis--l3">{{ item.crop_name }}</div>
            <div class="numbers">
              <div class="price">¥{{ item.one_price }}/亩</div>
              <div class="num">×{{ item.total_mu }}亩</div>
              <div class="all">合计：¥{{ item.total_price }}</div>
            </div>
          </div>
          <template #footer class="foot-bar">
            <div
              class="top"
              v-if="
                item.status == 4 ||
                  item.status == 5 ||
                  item.status == 2 ||
                  item.status == 3 ||
                  item.status == 0
              "
            >
              <div
                class="btn2"
                v-if="item.status == 4 || item.status == 5"
                @click.stop="goToMap(item.order_sn)"
              >
                查看轨迹
              </div>
              <div class="btn2" v-if="item.status == 2" @click.stop="warmWork(item.order_sn)">
                提醒接单
              </div>
              <div class="btn2" v-if="item.status == 3" @click.stop="warmWork(item.order_sn)">
                提醒作业
              </div>
              <div class="btn1 orange" v-if="item.status == 5" @click.stop="check(item.order_sn)">
                立即验收
              </div>
              <div
                class="btn1 orange"
                v-if="item.status == 0"
                @click.stop="pay(item.total_price, item.order_sn)"
              >
                立即付款
              </div>
            </div>
            <div class="bottom" v-if="item.wrong_str">{{ item.wrong_str }}</div>
          </template>
        </van-panel>
      </div>
    </van-list>
    <van-dialog
      v-model="dialog"
      title="确认验收?"
      :show-cancel-button="showBtn"
      :confirm-button-text="confirmText"
      confirm-button-color="#55CC99"
      :close-on-click-overlay="overlay"
      :before-close="beforeClose"
    >
      <div class="dialog-box">
        <p class="p1">
          {{
            dialogDataMakeSure.balance == 0
              ? '实际飞行面积=订单面积，请直接验收'
              : dialogDataMakeSure.balance > 0
              ? '实飞面积>订单面积，请支付差额'
              : '退回金额将原路返回'
          }}
        </p>
        <ul v-if="dialogDataMakeSure.balance != 0">
          <li>
            <span>订单面积</span>
            <span :class="{ gray: dialogDataMakeSure.balance < 0 }"
              >{{ dialogDataMakeSure.total_mu }}亩</span
            >
          </li>
          <li>
            <span>实飞面积</span>
            <span :class="{ gray: dialogDataMakeSure.balance > 0 }"
              >{{ dialogDataMakeSure.true_mu }}亩</span
            >
          </li>
          <li>
            <span>作物单价</span>
            <span>{{ dialogDataMakeSure.one_price }}元/亩</span>
          </li>
          <li>
            <span>{{ dialogDataMakeSure.balance < 0 ? '退回金额' : '支付金额' }}</span>
            <span
              :class="{
                orange: dialogDataMakeSure.balance > 0,
                green: dialogDataMakeSure.balance < 0,
              }"
              >¥{{ dialogDataMakeSure.balance }}</span
            >
          </li>
        </ul>
      </div>
    </van-dialog>
    <Pay ref="pay" :money="payMoney" :order="orderNumber" :directPay="directPay"></Pay>
  </div>
</template>
<script>
import axios from '../../http';
import Pay from '../../components/pay/pay';
import { mapState } from 'vuex';
export default {
  name: 'order',
  components: { Pay },
  props: {
    orderValue: '',
  },
  inject: ['reload'],
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      unusual: 'normal',
      last_id: '', //上一页最后数据的ID
      wrong_count: 0, //异常订单数
      dialogData: '', //验收弹窗数据
      dialog: false, //验收弹窗
      overlay: true, //是否显示遮罩层点击
      order_sn: '', //缓存订单号
      payMoney: 0, //支付金钱
      orderNumber: '', //订单号
      directPay: true,
      dialogDataMakeSure: '',
    };
  },
  computed: {
    ...mapState(['token']),
    showBtn() {
      //是否显示取消按钮
      if (this.dialogDataMakeSure.balance < 0) {
        return false;
      } else {
        return true;
      }
    },
    confirmText() {
      //确定按钮文案
      if (this.dialogDataMakeSure.balance > 0) {
        return '确认支付';
      } else {
        return '确认验收';
      }
    },
  },
  watch: {
    orderValue() {
      this.list = [];
      this.last_id = '';
      this.finished = false;
      this.unusual = 'normal';
      this.getOrderData();
    },
    unusual(newVal) {
      if (newVal == 'unusual') {
        this.list = [];
        this.last_id = '';
        this.finished = false;
        this.wrong_count = 0;
        this.unusualOrder();
      }
    },
  },
  mounted() {},
  destroyed() {},
  methods: {
    getOrderData() {
      //请求订单列表函数，也是上滑刷新，load函数
      // if (this.unusual == "unusual") {
      //   this.unusualOrder();
      // } else {
      //   this.normalOrder();
      // }
      if (this.unusual == 'normal') {
        this.normalOrder();
      }
    },
    orderStatus(number, refund) {
      //订单状态对应的文案
      let text = '';
      // if (refund && refund == 1 && number == 10) {
      //   text = "已完成（部分退款中)";
      //   return text;
      // }
      switch (number) {
        case 0:
          text = '待付款';
          break;
        case 1:
          text = '待审核';
          break;
        case 2:
          text = '待接单';
          break;
        case 3:
          text = '待作业';
          break;
        case 4:
          text = '作业中';
          break;
        case 5:
          text = '待验收';
          break;
        case 10:
          text = '已完成';
          break;
        case 12:
          text = '退款成功';
          break;
        case -1:
          text = '已取消';
          break;
      }
      return text;
    },
    goToOrderDetail(orderNumber) {
      this.$router.push({
        path: '/orderDetail',
        query: {
          orderNumber: orderNumber,
        },
      });
    },
    normalOrder() {
      //正常订单列表
      axios
        .fetchPost('/api/order/lists', {
          token: this.token,
          page_size: 10,
          last_id: this.last_id,
          status: this.orderValue,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.loading = false;
            data.data.list.forEach((element) => {
              this.list.push(element);
            });
            this.last_id = data.data.last_id;
            this.wrong_count = data.data.wrong_count;
            if (data.data.have_next == 0) {
              this.finished = true;
            }
          } else if (data.code == 210) {
            this.finished = true;
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    unusualOrder() {
      //异常订单列表
      axios
        .fetchPost('/api/order/wrong_list', {
          token: this.token,
          page_size: 10,
          last_id: this.last_id,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.loading = false;
            data.data.list.forEach((element) => {
              this.list.push(element);
            });
            this.last_id = data.data.last_id;
            if (data.data.have_next == 0) {
              this.finished = true;
            }
          } else if (data.code == 210) {
            this.finished = true;
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    check(order_sn, money) {
      //待验收按钮
      this.dialog = true; //验收弹窗
      this.order_sn = order_sn;
      axios
        .fetchPost('/api/order/accept', {
          token: this.token,
          order_sn: order_sn,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.dialogDataMakeSure = res.data.data;
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    beforeClose(action, done) {
      //确认验收
      let balance = this.dialogDataMakeSure.balance; //支付金额
      if (action == 'confirm') {
        if (this.confirmText == '确认支付') {
          this.$refs.pay.show = true;
          this.directPay = false;
          this.payMoney = balance;
          this.orderNumber = this.order_sn;
          done();
          return;
        }
        this.do_accept();
        done();
      } else {
        done();
      }
    },
    do_accept() {
      //确认验收
      axios
        .fetchPost('/api/order/do_accept', {
          token: this.token,
          order_sn: this.order_sn,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.$toast(data.msg);
            this.reload();
          } else {
            this.$toast(data.msg);
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    warmWork(order_sn) {
      //提醒作业 // 提醒接单 // 提醒结束作业
      axios
        .fetchPost('/api/order/notice', {
          token: this.token,
          order_sn: order_sn,
        })
        .then((res) => {
          let data = res.data;
          this.$toast(data.msg);
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },

    pay(money, order) {
      //立即付款
      this.directPay = true;
      this.$refs.pay.show = true;
      this.payMoney = parseFloat(money);
      this.orderNumber = order;
    },
    goToMap(order_sn) {
      //查看轨迹
      this.$router.push({
        path: '/flyDataOne',
        query: { order_sn: order_sn },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.order-wrap
  text-align left
  position relative
  background #efefef
  .tips
    position relative
    height 35px
    background #FF9922
    text-align center
    font-size 13px
    font-family Microsoft YaHei
    font-weight 400
    line-height 35px
    color rgba(255, 255, 255, 1)
  .van-list
    margin-top 14px
  .order-list
    margin-bottom 10px
    .time
      width 150px
      padding-left 13px
      font-size 12px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(255, 255, 255, 1)
      background rgba(85, 204, 153, 0.5)
      border-radius 20px
      border-top-left-radius 0
      border-bottom-left-radius 0
      margin-bottom 5px
    .head-bar
      display flex
      justify-content space-between
      height 40px
      line-height 40px
      padding 0 13px
      .left
        font-size 14px
        font-family Microsoft YaHei
        font-weight 400
        color rgba(40, 40, 40, 1)
      .right
        font-size 14px
        font-family Microsoft YaHei
        font-weight 400
        color rgba(255, 153, 34, 1)
        .right-text
          color rgba(255, 153, 34, 1)
          margin-left 10px
        &.sucess
          color #989898
    .order-info
      padding 20px 13px 9px
      display flex
      .imgs
        width 62px
        height 62px
        overflow hidden
        background green
        margin-right 10px
        & > img
          width 100%
          height 100%
      .name
        width 140px
        max-width 140px
        overflow hidden
      .numbers
        flex 1
        text-align right
        font-size 12px
        .price
          font-family Microsoft YaHei
          font-weight 400
          color rgba(40, 40, 40, 1)
        .num
          font-size 12px
          font-family Microsoft YaHei
          font-weight 400
          color rgba(153, 153, 153, 1)
        .all
          font-family Microsoft YaHei
          font-weight 400
          font-size 14px
          margin-top 13px
          line-height 1.2
          color rgba(40, 40, 40, 1)
    .van-panel__footer
      padding 0
      .top
        width 100%
        border-bottom 1px solid #e5e5e5
        display flex
        justify-content flex-end
        align-items center
        height 40px
        padding-right 12px
        & > div
          display inline-block
          margin-left 15px
          padding 6px 8px
          font-size 12px
          line-height 1.1
          border 1px solid rgba(153, 153, 153, 1)
          border-radius 25px
          color #666666
          position relative
          z-index 2
          &.orange
            background #FF9922
            font-family Microsoft YaHei
            font-weight 400
            border none
            color rgba(255, 255, 255, 1)
      .bottom
        width 100%
        height 40px
        line-height 40px
        font-size 12px
        color #FF0000
        padding-left 12px
  .dialog-box
    text-align left
    margin-top 20px
    padding 0 40px
    font-size 14px
    .p1
      color #989898
      margin-bottom 20px
    ul
      & > li
        display flex
        justify-content space-between
        margin-bottom 13px
        color #282828
        .orange
          color #FF9922
        .green
          color #55CC99
        .gray
          color #999999
</style>
